"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.providersStore = void 0;
const api_1 = require("client/api");
const ui_1 = require("client/components/ui");
const mobx_1 = require("mobx");
const ramda_1 = require("ramda");
class ProvidersStore {
    constructor() {
        this.editProvider = {};
        this.pads = { value: [] };
        this.providers = {
            value: []
        };
        this.provider = {};
        this.submission = {};
        this.submitted = false;
        this.selectedRowIndex = 0;
        this.parsedRows = []; // for header row selection
        this.importedProviders = [];
        this.importColumnsHeader = [
            // for header mapping
            // #TK added
            "thi           s",
            "list",
            "is",
            "for",
            "te        sting"
        ];
        // C-097 provider
        this.totalProviderPage = 1;
        this.currentPage = 1;
        // C-097 provider
        this.loadProviders = async (query = { page: 1, limit: 25 }) => {
            this.providers.loading = true;
            const result = await api_1.ProviderEndpoint.list.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.providers = { error: result.code };
            }
            else {
                this.providers = { value: result.providers };
                this.totalProviderPage = result.totalPages; // C-097 provider
                this.currentPage = result.currentPage; // C-097 provider 
            }
        };
        this.createProvider = async (provider) => {
            this.editProvider = { loading: true, status: ui_1.FormStatus.Saving };
            this.provider = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.provider.value
            };
            const result = await api_1.ProviderEndpoint.create.apiCall(null, {
                provider
            });
            if (api_1.isError(result)) {
                this.editProvider = { error: result.code, status: ui_1.FormStatus.Error };
                this.provider = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.provider.value
                };
                return false;
            }
            else {
                this.editProvider = { status: ui_1.FormStatus.Saved };
                this.provider = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(provider, result.provider)
                };
                return result.provider;
            }
        };
        this.readProviderSubmission = async (provider) => {
            this.provider = {
                loading: true,
                status: ui_1.FormStatus.Loading,
                value: this.provider.value
            };
            const result = await api_1.ProviderEndpoint.read.apiCall({
                params: { id: provider.id }
            });
            if (api_1.isError(result)) {
                this.provider = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.provider.value
                };
                return false;
            }
            else {
                const status = result.provider.sites.length === provider.sites.length
                    ? ui_1.FormStatus.Clean
                    : ui_1.FormStatus.Dirty;
                this.provider = {
                    status,
                    value: ramda_1.merge(result.provider, provider)
                };
                return ramda_1.merge(result.provider, provider);
            }
        };
        this.readProvider = async (id) => {
            this.provider = {
                loading: true,
                status: ui_1.FormStatus.Loading,
                value: this.provider.value
            };
            const result = await api_1.ProviderEndpoint.read.apiCall({
                params: { id }
            });
            if (api_1.isError(result)) {
                this.provider = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.provider.value
                };
                return false;
            }
            else {
                this.provider = { status: ui_1.FormStatus.Clean, value: result.provider };
                return result.provider;
            }
        };
        this.readNewProvider = async (provider) => {
            this.provider = { value: ramda_1.merge(this.provider, provider) };
            return provider;
        };
        this.saveProvider = async (provider) => {
            this.editProvider = { loading: true, status: ui_1.FormStatus.Saving };
            this.provider = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.provider.value
            };
            const result = await api_1.ProviderEndpoint.save.apiCall(null, {
                provider
            });
            if (api_1.isError(result)) {
                this.editProvider = { error: result.code, status: ui_1.FormStatus.Error };
                this.provider = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.provider.value
                };
                return false;
            }
            else {
                this.editProvider = { status: ui_1.FormStatus.Saved };
                this.provider = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(provider, result.provider)
                };
                this.loadProviders();
                return result.provider;
            }
        };
        this.deleteProvider = async (provider) => {
            const result = await api_1.ProviderEndpoint.remove.apiCall({
                params: { id: provider.id }
            });
            if (api_1.isError(result)) {
                this.providers = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.providers.value
                };
            }
            else {
                this.loadProviders();
            }
        };
        this.deleteUpload = async (uploadId) => {
            const result = await api_1.ProviderEndpoint.removeFile.apiCall({
                params: { id: uploadId }
            });
            if (api_1.isError(result)) {
                // this.upload = {
                //   error: result.code,
                //   value: this.uploads.value,
                // };
                console.log("error in delete upload:", result.code);
            }
            else {
                this.loadProviders();
            }
        };
        this.loadActivePads = async (provider) => {
            this.providers.loading = true;
            const siteIds = provider.sites ? provider.sites.map(site => site.id) : [];
            const result = await api_1.PadEndpoint.listactive.apiCall({
                params: { siteId: siteIds }
            });
            if (api_1.isError(result)) {
                this.pads = { error: result.code };
            }
            else {
                this.pads = { value: result.pads };
            }
        };
        this.promptSignature = async (pad, provider) => {
            this.providers.loading = true;
            const result = await api_1.PadEndpoint.promptSignature.apiCall(null, {
                pad,
                type: "provider",
                id: provider.id
            });
            if (api_1.isError(result)) {
                this.pads = { error: result.code };
            }
        };
        // Cloned and edited from /patients/store.ts for uploads.
        this.reset = () => {
            this.submission = {};
            this.submitted = false;
        };
        this.upload = async (files, providerId, uploadType) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newFile", file); // Why is name gone?
            });
            formData.append("providerId", providerId);
            formData.append("uploadType", uploadType);
            const response = await api_1.ProviderEndpoint.uploadFile.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
                alert(this.submission.error);
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
                this.loadProviders();
            }
        };
        this.updateAssetsDescriptions = async (uploads) => {
            console.log("uploads providers store", uploads);
            const result = await api_1.ProviderEndpoint.updateassetsdescriptions.apiCall(null, { uploads });
            if (api_1.isError(result)) {
                console.error("Error updating assets descriptions in providersStore");
            }
            else {
                console.info("Successfully updated assets descriptions in providersStore");
            }
        };
        this.getUploadsById = async (providerId) => {
            const uploads = await api_1.ProviderEndpoint.getUploads.apiCall({
                params: { id: providerId }
            });
        };
        this.import = async (files, siteId) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newProvider", file, file.name);
            });
            formData.append("siteId", siteId);
            let response = await api_1.ProviderEndpoint.parse.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
                return;
            }
            response = await api_1.ProviderEndpoint.submit.apiCall(null, {
                providers: response.providers,
                siteId
            });
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
            }
        };
        this.parse = async (files, siteId) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach((file) => {
                formData.append("newProvider", file, file.name);
            });
            formData.append("siteId", siteId);
            const response = await api_1.ProviderEndpoint.parse.apiCall(null, formData);
            // console.log("response is ", response);
            try {
                if (response.providers) {
                    this.parsedProviders = {
                        providers: response.providers,
                        siteId
                    };
                }
            }
            catch (e) {
                console.log(e);
            }
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
            }
            else {
                this.submission = { value: response.providers };
            }
        };
        this.parseImportsHeader = async (files, siteId) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newProvider", file, file.name);
            });
            formData.append("siteId", siteId);
            const response = await api_1.ProviderEndpoint.parseColumnsHeader.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
                throw Error("error in parsing");
            }
            else {
                this.parsedRows = response.parsedRows;
            }
        };
        this.submit = async (siteId) => {
            this.submission = { loading: true, value: this.submission.value };
            if (!this.submission.value) {
                this.submission = {};
                return;
            }
            const response = await api_1.ProviderEndpoint.submit.apiCall(null, {
                providers: this.submission.value,
                siteId
            });
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
            }
        };
        this.submitUserMappedProviderHeader = async (mappedProviders, siteId) => {
            this.submission = { loading: true, value: mappedProviders };
            if (!this.submission.value) {
                this.submission = {};
                return;
            }
            const response = await api_1.ProviderEndpoint.submit.apiCall(null, {
                providers: this.submission.value,
                siteId
            });
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
            }
        };
        this.getMissingRequiredAssets = async (loadedEntity, entityType) => {
            const result = await api_1.ProviderEndpoint.getMissingRequiredAssets.apiCall(null, {
                loadedEntity,
                entityType
            });
            if (api_1.isError(result)) {
                return false;
            }
            else {
                return result.missingRequiredAssets;
            }
        };
    }
}
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "editProvider", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "pads", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "providers", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "submission", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "submitted", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "providerHeaders", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "parsedProviders", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "selectedRowIndex", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "parsedRows", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "mappedHeadersObject", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "importedProviders", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "dbHeaders", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "importedFileAndSiteId", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "importColumnsHeader", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "totalProviderPage", void 0);
__decorate([
    mobx_1.observable
], ProvidersStore.prototype, "currentPage", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "loadProviders", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "createProvider", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "readProviderSubmission", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "readProvider", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "readNewProvider", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "saveProvider", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "deleteProvider", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "deleteUpload", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "loadActivePads", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "promptSignature", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "reset", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "upload", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "updateAssetsDescriptions", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "getUploadsById", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "import", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "parse", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "parseImportsHeader", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "submit", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "submitUserMappedProviderHeader", void 0);
__decorate([
    mobx_1.action
], ProvidersStore.prototype, "getMissingRequiredAssets", void 0);
exports.providersStore = new ProvidersStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/providers/store.ts
// module id = 193
// module chunks = 0